import { useEffect, useState } from 'react';
import { AuthWithCustomerTagsHook } from '@monofront/types';
import { getIsFreshUser, getIsUltraFreshUser } from '../utils';
import { useUserTags } from './useLocalTags';

export const ALGOLIA_CONTEXT_AUTOCOMPLETE_V2 = 'autocomplete_v2';
export const ALGOLIA_CONTEXT_INSTANT_SEARCH_V2 = 'instantsearch_v2';
export const ALGOLIA_CONTEXT_DISABLE_FRESH = 'disable-fresh';
export const ALGOLIA_CONTEXT_DISABLE_ULTRA_FRESH = 'disable-ultra-fresh';

const buildNewContext = (omsTags: Array<string>) => {
  const isFreshUser = getIsFreshUser(omsTags);
  const isUltraFreshUser = getIsUltraFreshUser(omsTags);
  const newContext: string[] = [];

  if (!isFreshUser) {
    newContext.push(ALGOLIA_CONTEXT_DISABLE_FRESH);
  }

  if (!isUltraFreshUser) {
    newContext.push(ALGOLIA_CONTEXT_DISABLE_ULTRA_FRESH);
  }

  return newContext;
};

/**
 * Factory function that build a useEnrichAlgoliaContexts hook
 * This hook is used to add contexts to Algolia queries depending on the user
 *
 * @param useAuthentication the hook that handles the authentication
 * @returns a hook that is to generate all contexts
 */
export const createUseEnrichAlgoliaContexts = (
  useAuthentication: AuthWithCustomerTagsHook,
) => {
  return (contexts: string[]): string[] => {
    const tags = useUserTags(useAuthentication);

    const [enrichedContexts, setEnrichedContexts] = useState<string[]>(
      buildNewContext(tags),
    );

    useEffect(() => {
      const newContext = buildNewContext(tags);

      if (JSON.stringify(newContext) !== JSON.stringify(enrichedContexts)) {
        setEnrichedContexts(newContext);
      }
    }, [tags]);

    return [...contexts, ...enrichedContexts];
  };
};
